var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"id"},[_c('sk-input',{attrs:{"placeholder":_vm.placeholder,"reg-exp":/[^0-9]/g,"mob-numeric-keyboard":true,"preselected-value":_vm.searchKey},on:{"fieldvaluechanged":_vm.onInputBoxChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }